import axios from "axios";

export default {
    namespaced: true,

    state: {
        blacklist: [],
        blacklist_history: [],
    },

    getters: {
        blacklist(state) {
            return state.blacklist;
        },
        blacklist_history(state) {
            return state.blacklist_history;
        },
    },

    mutations: {
        SET_BLACKLIST(state, blacklist) {
            return (state.blacklist = blacklist);
        },
        SET_BLACKLIST_HISTORY(state, history) {
            return (state.blacklist_history = history);
        },
    },

    actions: {
        async fetchBlacklist({ commit }, params) {
            await axios
                .get("/api/v1/blacklist", { params: params })
                .then((res) => {
                    commit("SET_BLACKLIST", res.data);
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },

        async fetchBlacklistHistory({ commit }, customer_id) {
            await axios
                .get(`/api/v1/blacklist/${customer_id}`)
                .then((res) => {
                    commit("SET_BLACKLIST_HISTORY", res.data);
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },

        async blacklistCustomer({ commit }, payload) {
            return await axios
                .post("/api/v1/blacklist", payload)
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },

        async unblacklistCustomer({ commit }, payload) {
            return await axios
                .post("/api/v1/blacklist/unblacklist", payload)
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },
    },
};
